/* global $ */
import React, { useRef, useState, useEffect, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import axios from 'axios';
import Swal from 'sweetalert2';

const CandidateRegistration = () => {
    const [data, setData] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [newRecord, setNewRecord] = useState({
        reg_form: "Fresh",
        candidate_type: "",
        certificate_type: "",
        training_atten_date: "",
        training_date: new Date(),
        batch_no: "",
        training_title: "",
        sr_no: "",
        organization: "",
        work_location: "",
        incharge: "",
        sub_contractor: "",
        evaluation_option: "",
        payment_made_by: "",
        contract_number: "",
        passport_size: "",
        stamp_size: "",
        Name: "",
        designation: "",
        contact_no: "",
        qualification: "",
        date_of_birth: "",
        languages_known: "",
        total_year_exp: "",
        current_employer: "",
        LMV_HMV_license_no: "",
        types_of_cranes_handled: "",
        marital_status: "",
        fees_amount: "",
        present_address: "",
        permanent_address: "",
        pre_evaluation_test: "",
        service_tax: "",
        license_valid_from: "",
        license_valid_to: "",
        amount_status: "",
        checked_by: "",
        verify_by: "",
        aadhaar_no: "",
        id_card: "",
    });
    const [searchText, setSearchText] = useState('');
    const [batchNumbers, setBatchNumbers] = useState([]);
    const [selectedBatchNo, setSelectedBatchNo] = useState('');
    const [trainingTitle, setTrainingTitle] = useState([]);
    const [organization, setOrganization] = useState([]);
    const [workLocation, setworkLocation] = useState([]);
    const [licenseType, setlicenseType] = useState([]);
    const [isAddressSame, setIsAddressSame] = useState(false);
    const [trainerName, settrainerName] = useState([]);
    const [printSignatures, setPrintSignatures] = useState({ checkedBy: '', verifiedBy: '', authorizedBy: '' });
    const [formErrors, setFormErrors] = useState({});

    const REQUIRED_FIELDS = {
        candidate_type: 'Candidate Type',
        training_atten_date: 'Training Attendance Date',
        training_date: 'Date Of Issue',
        batch_no: 'Batch No',
        training_title: 'Training Title',
        sr_no: 'Roll No',
        organization: 'Organization',
        work_location: 'Work Location',
        incharge: 'Incharge',
        sub_contractor: 'Sub Contractor',
        evaluation_option: 'Evaluation Options',
        payment_made_by: 'Payment Made By',
        contract_number: 'Contract Number',
        Name: 'Name',
        designation: 'Designation',
        contact_no: 'Contact No',
        qualification: 'Qualification',
        date_of_birth: 'Date of Birth',
        languages_known: 'Languages Known',
        total_year_exp: 'Total Year Experience',
        current_employer: 'Current Employer',
        LMV_HMV_license_no: 'LMV/HMV License No',
        types_of_cranes_handled: 'Driving License Type',
        marital_status: 'Marital Status',
        aadhaar_no: 'Aadhaar No',
        id_card: 'ID Card',
        present_address: 'Present Address',
        permanent_address: 'Permanent Address',
        checked_by: 'Checked By',
        verify_by: 'Verified By',
    };

    const validateForm = () => {
        const errors = {};
        Object.entries(REQUIRED_FIELDS).forEach(([key, label]) => {
            if (!newRecord[key] || String(newRecord[key]).trim() === '') {
                errors[key] = label;
            }
        });
        /* file fields — valid if a URL already saved OR a new file selected */
        if (!newRecord.passport_size && !fileInputs.passport_size) errors.passport_size = 'Passport Size Photo';
        if (!newRecord.stamp_size && !fileInputs.stamp_size) errors.stamp_size = 'Stamp Size Photo';
        return errors;
    };

    /* helpers for JSX */
    const fe = (field) => !!formErrors[field]; /* has error */
    const labelCls = (field) => `form-label fw-bold ${fe(field) ? 'text-danger' : 'text-primary'}`;
    const inputCls = (field) => `form-control${fe(field) ? ' is-invalid' : ''}`;
    const selectCls = (field) => `form-control select2${fe(field) ? ' is-invalid' : ''}`;
    const fileInputRef1 = useRef(null);
    const fileInputRef2 = useRef(null);
    const [fileKey, setFileKey] = useState(Date.now());
    const [fileInputs, setFileInputs] = useState({
        passport_size: null,
        stamp_size: null,
    });
    const [imageSaved, setImageSaved] = useState(true);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        const handleModalClose = () => {
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();

            $('body').css({
                'padding-right': '',
                'overflow': ''
            });

            $('.content-wrapper').css('min-height', 'calc(100vh - 114px)');
        };

        $('#editRowModal').on('hidden.bs.modal', handleModalClose);
        return () => $('#editRowModal').off('hidden.bs.modal', handleModalClose);
    }, []);


    useEffect(() => {
        const fetchBatchNumbers = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/batchno_tab');

                // Extract unique batch numbers for the dropdown
                const uniqueBatchNumbers = [...new Set(response.data.map(item => item.batch_no))];
                setBatchNumbers(uniqueBatchNumbers);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchBatchNumbers();
    }, []);

    useEffect(() => {
        const fetchTrainingTitle = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/training_titles');
                // Use a Map to ensure unique training titles while keeping the original object structure
                const uniqueTrainingTitle = Array.from(
                    new Map(response.data.map(item => [item.training_title, item])).values()
                );
                setTrainingTitle(uniqueTrainingTitle);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchTrainingTitle();
    }, []);

    useEffect(() => {
        const fetchOrganization = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/organization_details');
                // Use a Map to ensure unique training titles while keeping the original object structure
                const uniqueOrganization = Array.from(
                    new Map(response.data.map(item => [item.organ_name, item])).values()
                );
                setOrganization(uniqueOrganization);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchOrganization();
    }, []);

    useEffect(() => {
        const fetchworkLocation = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/work_location');
                // Use a Map to ensure unique training titles while keeping the original object structure
                const uniqueworkLocation = Array.from(
                    new Map(response.data.map(item => [item.loc_name, item])).values()
                );
                setworkLocation(uniqueworkLocation);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchworkLocation();
    }, []);

    useEffect(() => {
        const fetchlicenseType = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/driving_license_type');
                // Use a Map to ensure unique training titles while keeping the original object structure
                const uniquelicenseType = Array.from(
                    new Map(response.data.map(item => [item.driving_li_type, item])).values()
                );
                setlicenseType(uniquelicenseType);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchlicenseType();
    }, []);

    useEffect(() => {
        const fetchtrainerName = async () => {
            try {
                const response = await axios.get('https://api.eazyworldehsengineering.com/api/trainer_name_tab');
                // Use a Map to ensure unique training titles while keeping the original object structure
                const uniquetrainerName = Array.from(
                    new Map(response.data.map(item => [item.trainer_name, item])).values()
                );
                settrainerName(uniquetrainerName);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchtrainerName();
    }, []);

    useEffect(() => {
        if (newRecord.present_address && newRecord.permanent_address) {
            setIsAddressSame(newRecord.present_address === newRecord.permanent_address);
        }
    }, [newRecord.present_address, newRecord.permanent_address]);

    // Handle file input change
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            setFileInputs((prev) => ({ ...prev, [name]: files[0] }));
            if (name === 'passport_size') setImageSaved(false);
        }
    };

    // Save only the image for an existing record
    const handleImageSave = async () => {
        if (!selectedRow?.mas_id || !fileInputs.passport_size) return;
        const fd = new FormData();
        fd.append('passport_size', fileInputs.passport_size);
        try {
            await axios.put(
                `https://api.eazyworldehsengineering.com/api/candidate_registration/${selectedRow.mas_id}`,
                fd, { headers: { 'Content-Type': 'multipart/form-data' } }
            );
            setImageSaved(true);
            Swal.fire('Saved!', 'Image saved successfully.', 'success');
        } catch {
            Swal.fire('Error!', 'Image save failed. Please try again.', 'error');
        }
    };



    const handleInputChange = (e) => {
        const { id, value } = e.target;

        if (formErrors[id]) setFormErrors(prev => { const n = { ...prev }; delete n[id]; return n; });

        // Create a new object to update the state correctly
        const updatedRecord = { ...newRecord, [id]: value };

        // If present_address is changed and isAddressSame is true, update both addresses
        if (isAddressSame && id === "present_address") {
            updatedRecord.permanent_address = value;
        }

        // Selecting a work location fills in the incharge mapped to it
        if (id === "work_location") {
            const selected = workLocation.find(loc => loc.loc_name === value);
            updatedRecord.incharge = selected?.incharge || "";
            if (formErrors.incharge) setFormErrors(prev => { const n = { ...prev }; delete n.incharge; return n; });
        }

        // Update the state with the new record
        setNewRecord(updatedRecord);
    };

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setIsAddressSame(isChecked);

        if (isChecked) {
            setNewRecord({ ...newRecord, permanent_address: newRecord.present_address });
        } else {
            setNewRecord({ ...newRecord, permanent_address: "" });
        }
    };

    const handleViewButtonClick = async () => {
        if (!selectedBatchNo) {
            Swal.fire('Error!', 'Please select a batch number.', 'error');
            return;
        }

        try {
            const response = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/?batch_no=${selectedBatchNo}`);
            setData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire('Error!', 'There was an issue fetching the data.', 'error');
        }
    };

    const handleDelete = useCallback(async (mas_id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });
        if (result.isConfirmed) {
            try {
                await axios.delete(`https://api.eazyworldehsengineering.com/api/candidate_registration/${mas_id}`);
                Swal.fire('Deleted!', 'The record has been deleted.', 'success');
                setData(data.filter(item => item.mas_id !== mas_id));
            } catch (error) {
                console.error('Error deleting data:', error);
                Swal.fire('Error!', 'There was an issue deleting the record.', 'error');
            }
        }

    }, [data]);



    const convertToYYYYMMDD = (dateStr) => {
        const date = new Date(dateStr);
        if (isNaN(date)) return ""; // Return empty if date is invalid
        return date.toISOString().split('T')[0]; // Convert to YYYY-MM-DD format
    };

    const isValidDate = (date) => {
        return date instanceof Date && !isNaN(date);
    };


    const handleView = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to view this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, view it!',
        });


        if (result.isConfirmed) {
            setSelectedRow(row);
            setNewRecord({
                reg_form: row.reg_form || "",
                candidate_type: row.candidate_type || "",
                certificate_type: row.certificate_type || "",
                training_atten_date: isValidDate(new Date(row.training_atten_date)) ? convertToYYYYMMDD(row.training_atten_date) : "",
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                batch_no: row.batch_no || "",
                training_title: row.training_title || "",
                sr_no: row.sr_no || "",
                organization: row.organization || "",
                work_location: row.work_location || "",
                incharge: row.incharge || "",
                sub_contractor: row.sub_contractor || "",
                evaluation_option: row.evaluation_option || "",
                payment_made_by: row.payment_made_by || "",
                contract_number: row.contract_number || "",
                passport_size: row.passport_size || "",
                stamp_size: row.stamp_size || "",
                Name: row.Name || "",
                designation: row.designation || "",
                contact_no: row.contact_no || "",
                qualification: row.qualification || "",
                date_of_birth: isValidDate(new Date(row.date_of_birth)) ? convertToYYYYMMDD(row.date_of_birth) : "",
                languages_known: row.languages_known || "",
                total_year_exp: row.total_year_exp || "",
                current_employer: row.current_employer || "",
                LMV_HMV_license_no: row.LMV_HMV_license_no || "",
                types_of_cranes_handled: row.types_of_cranes_handled || "",
                marital_status: row.marital_status || "",
                fees_amount: row.fees_amount || "",
                present_address: row.present_address || "",
                permanent_address: row.permanent_address || "",
                pre_evaluation_test: row.pre_evaluation_test || "",
                service_tax: row.service_tax || "",
                license_valid_from: row.license_valid_from || "",
                license_valid_to: row.license_valid_to || "",
                amount_status: row.amount_status || "",
                checked_by: row.checked_by || "",
                verify_by: row.verify_by || "",
                aadhaar_no: row.aadhaar_no || "",
                id_card: row.id_card || "",
            });
            $('#viewRowModal').modal('show');
        }
    };

    const handleEdit = async (row) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to edit this record?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, edit it!',
        });


        if (result.isConfirmed) {
            setSelectedRow(row);
            setNewRecord({
                reg_form: row.reg_form || "",
                candidate_type: row.candidate_type || "",
                certificate_type: row.certificate_type || "",
                training_atten_date: isValidDate(new Date(row.training_atten_date)) ? convertToYYYYMMDD(row.training_atten_date) : "",
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                batch_no: row.batch_no || "",
                training_title: row.training_title || "",
                sr_no: row.sr_no || "",
                organization: row.organization || "",
                work_location: row.work_location || "",
                incharge: row.incharge || "",
                sub_contractor: row.sub_contractor || "",
                evaluation_option: row.evaluation_option || "",
                payment_made_by: row.payment_made_by || "",
                contract_number: row.contract_number || "",
                passport_size: row.passport_size || "",
                stamp_size: row.stamp_size || "",
                Name: row.Name || "",
                designation: row.designation || "",
                contact_no: row.contact_no || "",
                qualification: row.qualification || "",
                date_of_birth: isValidDate(new Date(row.date_of_birth)) ? convertToYYYYMMDD(row.date_of_birth) : "",
                languages_known: row.languages_known || "",
                total_year_exp: row.total_year_exp || "",
                current_employer: row.current_employer || "",
                LMV_HMV_license_no: row.LMV_HMV_license_no || "",
                types_of_cranes_handled: row.types_of_cranes_handled || "",
                marital_status: row.marital_status || "",
                fees_amount: row.fees_amount || "",
                present_address: row.present_address || "",
                permanent_address: row.permanent_address || "",
                pre_evaluation_test: row.pre_evaluation_test || "",
                service_tax: row.service_tax || "",
                license_valid_from: row.license_valid_from || "",
                license_valid_to: row.license_valid_to || "",
                amount_status: row.amount_status || "",
                checked_by: row.checked_by || "",
                verify_by: row.verify_by || "",
                aadhaar_no: row.aadhaar_no || "",
                id_card: row.id_card || "",
            });
            $('#editRowModal').modal('show');
        }
    };

    const handlePrint = async (row) => {
        const trainerOptions = trainerName
            .map(t => `<option value="${t.trainer_name}">${t.trainer_name}</option>`)
            .join('');
        const selectStyle = 'width:100%;padding:6px 8px;margin-bottom:14px;border:1px solid #ccc;border-radius:4px;font-size:14px';

        const { value: sigs, isConfirmed } = await Swal.fire({
            title: 'Select Signatories',
            width: 420,
            html: `<div style="text-align:left;padding:0 6px">
                <label style="display:block;font-weight:bold;margin-bottom:4px">Checked by:</label>
                <select id="sw-checked" style="${selectStyle}">
                    <option value="">-- Select --</option>${trainerOptions}
                </select>
                <label style="display:block;font-weight:bold;margin-bottom:4px">Verified by:</label>
                <select id="sw-verified" style="${selectStyle}">
                    <option value="">-- Select --</option>${trainerOptions}
                </select>
                <label style="display:block;font-weight:bold;margin-bottom:4px">Authorized by:</label>
                <select id="sw-authorized" style="${selectStyle.replace('margin-bottom:14px', 'margin-bottom:0')}">
                    <option value="">-- Select --</option>${trainerOptions}
                </select>
            </div>`,
            showCancelButton: true,
            confirmButtonText: 'Print',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            preConfirm: () => ({
                checkedBy: document.getElementById('sw-checked').value,
                verifiedBy: document.getElementById('sw-verified').value,
                authorizedBy: document.getElementById('sw-authorized').value,
            })
        });

        if (!isConfirmed) return;
        setPrintSignatures(sigs);

        if (true) {

            const updatedRecord = {
                reg_form: row.reg_form,
                candidate_type: row.candidate_type,
                certificate_type: row.certificate_type,
                training_atten_date: isValidDate(new Date(row.training_atten_date)) ? convertToYYYYMMDD(row.training_atten_date) : "",
                training_date: isValidDate(new Date(row.training_date)) ? convertToYYYYMMDD(row.training_date) : "",
                batch_no: row.batch_no,
                training_title: row.training_title,
                sr_no: row.sr_no,
                organization: row.organization,
                work_location: row.work_location,
                incharge: row.incharge,
                sub_contractor: row.sub_contractor,
                evaluation_option: row.evaluation_option,
                payment_made_by: row.payment_made_by,
                contract_number: row.contract_number,
                passport_size: row.passport_size,
                stamp_size: row.stamp_size,
                Name: row.Name,
                designation: row.designation,
                contact_no: row.contact_no,
                qualification: row.qualification,
                date_of_birth: isValidDate(new Date(row.date_of_birth)) ? convertToYYYYMMDD(row.date_of_birth) : "",
                languages_known: row.languages_known,
                total_year_exp: row.total_year_exp,
                current_employer: row.current_employer,
                LMV_HMV_license_no: row.LMV_HMV_license_no,
                types_of_cranes_handled: row.types_of_cranes_handled,
                marital_status: row.marital_status,
                fees_amount: row.fees_amount,
                present_address: row.present_address,
                permanent_address: row.permanent_address,
                pre_evaluation_test: row.pre_evaluation_test,
                service_tax: row.service_tax,
                license_valid_from: row.license_valid_from || "",
                license_valid_to: row.license_valid_to || "",
                amount_status: row.amount_status,
                checked_by: row.checked_by,
                verify_by: row.verify_by,
                aadhaar_no: row.aadhaar_no,
                id_card: row.id_card,
            };

            setNewRecord(updatedRecord);
            setSelectedRow(row);

            setTimeout(() => {
                const content = document.getElementById('print_registration_section');

                const printWindow = window.open('', '');
                printWindow.document.write(`
                    <html>
                        <head>
                        <title>Print</title>
                        <style>
                            @media print {
                            @page {
                                size: A4;
                                margin: 5mm;
                            }
                            body {
                                margin: 0;
                                font-size: 9px;
                                font-family: Arial, sans-serif;
                                color: #000;
                                line-height: 1.1;
                            }
                            img {
                                max-width: 100%;
                            }
                            table {
                                width: 100%;
                                border-collapse: collapse;
                            }
                            td {
                                padding: 1px 3px;
                                vertical-align: top;
                            }
                            }
                        </style>
                        </head>
                        <body>
                        ${content.innerHTML}
                        </body>
                    </html>
                `);
                printWindow.document.close();
                printWindow.document.body.style.visibility = 'hidden';

                const images = printWindow.document.images;

                let loadedImages = 0;

                const doPrint = () => {
                    printWindow.document.body.style.visibility = 'visible';
                    printWindow.focus();
                    printWindow.print();
                    printWindow.close();
                };

                if (images.length === 0) {
                    doPrint();
                } else {

                    for (const img of images) {

                        if (img.complete && img.naturalWidth > 0) {
                            loadedImages++;
                        } else {

                            img.onload = () => {
                                loadedImages++;

                                if (loadedImages === images.length) {
                                    doPrint();
                                }
                            };

                            img.onerror = () => {
                                loadedImages++;

                                if (loadedImages === images.length) {
                                    doPrint();
                                }
                            };
                        }
                    }

                    if (loadedImages === images.length) {
                        doPrint();
                    }
                }
            }, 1000); // Wait to ensure setNewRecord applies before printing
        }
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        if (isSaving) return;

        setIsSaving(true);
        if (!selectedRow) {
            setIsSaving(false);
            return;
        }

        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            await Swal.fire({
                title: 'Required Fields Missing',
                html: `<div style="text-align:left;max-height:200px;overflow-y:auto">
                    ${Object.values(errors).map(l => `<div style="color:#dc3545;padding:2px 0">&#9679; ${l}</div>`).join('')}
                </div>`,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            });
            setIsSaving(false);
            return;
        }
        setFormErrors({});

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to save the changes?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, save it!'
        });

        if (!result.isConfirmed) {
            setIsSaving(false);
            return;
        }
        const formData = new FormData();

        formData.append('mas_id', selectedRow.mas_id);
        formData.append('reg_form', newRecord.reg_form);
        formData.append('candidate_type', newRecord.candidate_type);
        formData.append('certificate_type', newRecord.certificate_type);
        formData.append('training_atten_date', newRecord.training_atten_date);
        formData.append('training_date', newRecord.training_date);
        formData.append('batch_no', newRecord.batch_no);
        formData.append('training_title', newRecord.training_title);
        formData.append('sr_no', newRecord.sr_no);
        formData.append('organization', newRecord.organization);
        formData.append('work_location', newRecord.work_location);
        formData.append('incharge', newRecord.incharge);
        formData.append('sub_contractor', newRecord.sub_contractor);
        formData.append('evaluation_option', newRecord.evaluation_option);
        formData.append('payment_made_by', newRecord.payment_made_by);
        formData.append('contract_number', newRecord.contract_number);
        formData.append('Name', newRecord.Name);
        formData.append('designation', newRecord.designation);
        formData.append('contact_no', newRecord.contact_no);
        formData.append('qualification', newRecord.qualification);
        formData.append('date_of_birth', newRecord.date_of_birth);
        formData.append('languages_known', newRecord.languages_known);
        formData.append('total_year_exp', newRecord.total_year_exp);
        formData.append('current_employer', newRecord.current_employer);
        formData.append('LMV_HMV_license_no', newRecord.LMV_HMV_license_no);
        formData.append('types_of_cranes_handled', newRecord.types_of_cranes_handled);
        formData.append('marital_status', newRecord.marital_status);
        formData.append('fees_amount', newRecord.fees_amount);
        formData.append('present_address', newRecord.present_address);
        formData.append('permanent_address', newRecord.permanent_address);
        formData.append('pre_evaluation_test', newRecord.pre_evaluation_test);
        formData.append('service_tax', newRecord.service_tax);
        formData.append('license_valid_from', newRecord.license_valid_from);
        formData.append('license_valid_to', newRecord.license_valid_to);
        formData.append('amount_status', newRecord.amount_status);
        formData.append('checked_by', newRecord.checked_by);
        formData.append('verify_by', newRecord.verify_by);
        formData.append('aadhaar_no', newRecord.aadhaar_no);
        formData.append('id_card', newRecord.id_card);

        if (fileInputs.passport_size) {
            formData.append('passport_size', fileInputs.passport_size);
        }
        if (fileInputs.stamp_size) {
            formData.append('stamp_size', fileInputs.stamp_size);
        }

        try {
            const response = await axios.put(
                `https://api.eazyworldehsengineering.com/api/candidate_registration/${selectedRow.mas_id}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            const updatedItem = {
                ...newRecord,
                passport_size: response.data.passport_size || newRecord.passport_size,
                stamp_size: response.data.stamp_size || newRecord.stamp_size
            };

            setNewRecord(updatedItem);

            setData(prevData =>
                prevData.map(item =>
                    item.mas_id === selectedRow.mas_id
                        ? { ...item, ...updatedItem }
                        : item
                )
            );

            await Swal.fire(
                'Saved!',
                'The record has been updated.',
                'success'
            );
        } catch (error) {
            console.error('Error updating data:', error);
            Swal.fire('Error!', 'There was an issue updating the record.', 'error');
        }
        finally {

            setIsSaving(false);

        }

    };


    // Reference to the file input
    const fileInputRef = useRef(null);

    const handleCreateSubmit = async (event) => {
        event.preventDefault();
        if (isSaving) return;

        setIsSaving(true);
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            await Swal.fire({
                title: 'Required Fields Missing',
                html: `<div style="text-align:left;max-height:200px;overflow-y:auto">
                    ${Object.values(errors).map(l => `<div style="color:#dc3545;padding:2px 0">&#9679; ${l}</div>`).join('')}
                </div>`,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            });
            setIsSaving(false);
            return;
        }
        setFormErrors({});

        const formData = new FormData();

        // Append non-file fields
        formData.append('reg_form', newRecord.reg_form);
        formData.append('candidate_type', newRecord.candidate_type);
        formData.append('certificate_type', newRecord.certificate_type);
        formData.append('training_atten_date', newRecord.training_atten_date);
        formData.append('training_date', newRecord.training_date);
        formData.append('batch_no', newRecord.batch_no);
        formData.append('training_title', newRecord.training_title);
        formData.append('sr_no', newRecord.sr_no);
        formData.append('organization', newRecord.organization);
        formData.append('work_location', newRecord.work_location);
        formData.append('incharge', newRecord.incharge);
        formData.append('sub_contractor', newRecord.sub_contractor);
        formData.append('evaluation_option', newRecord.evaluation_option);
        formData.append('payment_made_by', newRecord.payment_made_by);
        formData.append('contract_number', newRecord.contract_number);
        formData.append('Name', newRecord.Name);
        formData.append('designation', newRecord.designation);
        formData.append('contact_no', newRecord.contact_no);
        formData.append('qualification', newRecord.qualification);
        formData.append('date_of_birth', newRecord.date_of_birth);
        formData.append('languages_known', newRecord.languages_known);
        formData.append('total_year_exp', newRecord.total_year_exp);
        formData.append('current_employer', newRecord.current_employer);
        formData.append('LMV_HMV_license_no', newRecord.LMV_HMV_license_no);
        formData.append('types_of_cranes_handled', newRecord.types_of_cranes_handled);
        formData.append('marital_status', newRecord.marital_status);
        formData.append('fees_amount', newRecord.fees_amount);
        formData.append('present_address', newRecord.present_address);
        formData.append('permanent_address', newRecord.permanent_address);
        formData.append('pre_evaluation_test', newRecord.pre_evaluation_test);
        formData.append('service_tax', newRecord.service_tax);
        formData.append('license_valid_from', newRecord.license_valid_from);
        formData.append('license_valid_to', newRecord.license_valid_to);
        formData.append('amount_status', newRecord.amount_status);
        formData.append('checked_by', newRecord.checked_by);
        formData.append('verify_by', newRecord.verify_by);
        formData.append('aadhaar_no', newRecord.aadhaar_no);
        formData.append('id_card', newRecord.id_card);
        // ✅ Append file inputs only on submit
        if (fileInputs.passport_size) {
            formData.append('passport_size', fileInputs.passport_size);
        }

        if (fileInputs.stamp_size) {
            formData.append('stamp_size', fileInputs.stamp_size);
        }

        try {
            const response = await axios.post('https://api.eazyworldehsengineering.com/api/candidate_registration/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            console.log(response);

            $('#addRowModal').modal('hide').on('hidden.bs.modal', function () {
                setTimeout(() => {
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    $('body').css('padding-right', '');
                    $('body').css('overflow', '');
                }, 500);
            });

            setData(prevData => [...prevData, response.data]);

            setNewRecord({
                reg_form: "Fresh",
                candidate_type: "",
                certificate_type: "",
                training_atten_date: "",
                training_date: "",
                batch_no: "",
                training_title: "",
                sr_no: "",
                organization: "",
                work_location: "",
                incharge: "",
                sub_contractor: "",
                evaluation_option: "",
                payment_made_by: "",
                contract_number: "",
                passport_size: "",
                stamp_size: "",
                Name: "",
                designation: "",
                contact_no: "",
                qualification: "",
                date_of_birth: "",
                languages_known: "",
                total_year_exp: "",
                current_employer: "",
                LMV_HMV_license_no: "",
                types_of_cranes_handled: "",
                marital_status: "",
                fees_amount: "",
                present_address: "",
                permanent_address: "",
                pre_evaluation_test: "",
                service_tax: "",
                license_valid_from: "",
                license_valid_to: "",
                amount_status: "",
                checked_by: "",
                verify_by: "",
                aadhaar_no: "",
                id_card: "",
            });

            setFileInputs({ passport_size: null, stamp_size: null });
            setImageSaved(true);

            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }

            await Swal.fire('Created!', 'The record has been Created.', 'success');
        } catch (error) {
            console.error('Error creating new record:', error);
            Swal.fire('Error!', 'There was an issue on creating the record.', 'error');
        } finally {

            setIsSaving(false);

        }
    };


    const handleAddButtonClick = () => {
        setNewRecord({
            reg_form: "Fresh",
            candidate_type: "",
            certificate_type: "",
            training_atten_date: "",
            training_date: "",
            batch_no: "",
            training_title: "",
            sr_no: "",
            organization: "",
            work_location: "",
            incharge: "",
            sub_contractor: "",
            evaluation_option: "",
            payment_made_by: "",
            contract_number: "",
            passport_size: "",
            stamp_size: "",
            Name: "",
            designation: "",
            contact_no: "",
            qualification: "",
            date_of_birth: "",
            languages_known: "",
            total_year_exp: "",
            current_employer: "",
            LMV_HMV_license_no: "",
            types_of_cranes_handled: "",
            marital_status: "",
            fees_amount: "",
            present_address: "",
            permanent_address: "",
            pre_evaluation_test: "",
            service_tax: "",
            license_valid_from: "",
            license_valid_to: "",
            amount_status: "",
            checked_by: "",
            verify_by: "",
            aadhaar_no: "",
            id_card: "",
        });
        $('#addRowModal').modal('show');
    };

    const handleResetButtonClick = () => {
        setSelectedBatchNo(''); // Clear dropdown selection
        setData([]); // Clear DataTable data
    };

    const filteredData = data.filter(item => {
        return (
            (item.sr_no && item.sr_no.toLowerCase().includes(searchText.toLowerCase())) ||
            (item.Name && item.Name.toLowerCase().includes(searchText.toLowerCase()))
        );
    });


    const columns = [
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>No</span>,
            selector: (row, index) => index + 1,
            sortable: true,
            width: '70px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Batch No</span>,
            selector: row => row.batch_no,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>R.No</span>,
            selector: row => row.sr_no,
            sortable: true,
            width: '120px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Reg Opt</span>,
            selector: row => row.reg_form,
            sortable: true,
            width: '100px',
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Name</span>,
            selector: row => row.Name,
            width: '200px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Training Title</span>,
            selector: row => row.training_title,
            width: '300px',
            sortable: true,
            wrap: true, // You can use this to wrap text
            cell: row => (
                <div style={{ fontWeight: '500', whiteSpace: 'normal', wordWrap: 'break-word', textAlign: 'left' }}>
                    {row.training_title}
                </div>
            ),
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Contact No</span>,
            selector: row => row.contact_no,
            width: '150px',
            sortable: true,
            style: {
                fontWeight: '500'
            }
        },
        {
            name: <span style={{ textTransform: 'uppercase', fontSize: '14px', fontWeight: 'bold' }}>Action</span>,
            cell: row => (
                <div>
                    <button className="btn btn-dark btn-sm" style={{ marginRight: '8px' }} onClick={() => handleView(row)}>
                        <i className="fa fa-eye"></i>
                    </button>
                    <button className="btn btn-primary btn-sm" style={{ marginRight: '8px' }} onClick={() => handleEdit(row)}>
                        <i className="fa fa-edit"></i>
                    </button>
                    <button className="btn btn-danger btn-sm" style={{ marginRight: '8px' }} onClick={() => handleDelete(row.mas_id)}>
                        <i className="fa fa-trash"></i>
                    </button>
                    <button className="btn btn-success btn-sm" onClick={() => handlePrint(row)}>
                        <i className="fa fa-print"></i>
                    </button>
                </div>
            ),
            width: '180px',
            ignoreRowClick: true,
            allowoverflow: true,
        }
    ];

    return (

        <div className="content-wrapper">
            {/* Page Header */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Candidate Registration</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Candidate Registration</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            {/* Action & Filter Section */}
            <div className="row mb-2">
                <div className="col-md-12">
                    <div className="card card-primary card-outline">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h5 className="card-title"><i className="fas fa-filter mr-2"></i> Filter Records</h5>
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={handleAddButtonClick}
                                data-bs-toggle="modal"
                                data-bs-target="#addRowModal"
                            >
                                <i className="fa fa-plus mr-1"></i> Add New
                            </button>
                        </div>
                        <div className="card-body">
                            <div className="form-row align-items-end">
                                <div className="form-group col-md-3"></div>

                                <div className="form-group col-md-3">
                                    <label>Batch Number</label>
                                    <select
                                        id="batchNumber"
                                        className="form-control select2"
                                        value={selectedBatchNo}
                                        onChange={(e) => setSelectedBatchNo(e.target.value)}
                                    >
                                        <option value="">Select a batch number</option>
                                        {batchNumbers.map((batchNo) => (
                                            <option key={batchNo} value={batchNo}>{batchNo}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group col-md-3 d-flex gap-2">
                                    <button className="btn btn-primary mr-2" onClick={handleViewButtonClick}>
                                        <i className="fas fa-eye mr-1"></i> View
                                    </button>
                                    <button className="btn btn-secondary" onClick={handleResetButtonClick}>
                                        <i className="fas fa-redo mr-1"></i> Reset
                                    </button>
                                </div>

                                <div className="form-group col-md-3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Table Section */}
            <div className="row">
                <div className="col-12">
                    <div className="card card-info card-outline">
                        <div className="card-header">
                            <h5 className="card-title"><i className="fas fa-table mr-2"></i> Candidate List</h5>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="form-control mb-3"
                                />
                            </div>

                            <div className="table-responsive">
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    pagination
                                    paginationPerPage={100}
                                    paginationRowsPerPageOptions={[100, 200, 300, 400]}
                                    highlightOnHover
                                    striped
                                    className="table table-bordered table-hover"
                                />

                                {/* View Modal */}
                                <div className="modal fade" id="viewRowModal">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary text-white">
                                                <h4 className="modal-title"><i class="fas fa-user-plus mr-2"></i> Candidate Registration Details</h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleFormSubmit}>

                                                    <div className='row mb-3'>
                                                        <div className="col-md-4">
                                                            <label class="form-label text-primary fw-bold">Registration Form</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="reg_form"
                                                                value={newRecord.reg_form}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value="Fresh">Fresh</option>
                                                                <option value="Renewal">Renewal</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label class="form-label text-primary fw-bold">Candidate Type</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="candidate_type"
                                                                value={newRecord.candidate_type}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value=""></option>
                                                                <option value="Management">Management</option>
                                                                <option value="Plant & Machinery">Plant & Machinery</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label class="form-label text-primary fw-bold">Certificate Type</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="certificate_type"
                                                                value={newRecord.certificate_type}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value=""></option>
                                                                <option value="BMRCL PM">BMRCL PM</option>
                                                                <option value="CMRL CPR">CMRL CPR</option>
                                                                <option value="CMRL MG">CMRL MG</option>
                                                                <option value="CMRL PM">CMRL PM</option>
                                                                <option value="MMRCL CPR">MMRCL CPR</option>
                                                                <option value="MMRCL PM">MMRCL PM</option>
                                                                <option value="PMCR">PMCR</option>
                                                                <option value="CMRL PM WSC">CMRL PM WSC</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className="col-md-6">
                                                            <label className={labelCls('training_atten_date')}>Training Atten Date {fe('training_atten_date') && <span>*</span>}</label>
                                                            <input
                                                                id="training_atten_date"
                                                                type="date"
                                                                value={newRecord.training_atten_date} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        training_atten_date: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                                disabled
                                                            />
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className={labelCls('training_date')}>Date Of Issue {fe('training_date') && <span>*</span>}</label>
                                                            <input
                                                                id="training_date"
                                                                type="date"
                                                                value={newRecord.training_date} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        training_date: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Batch No</label>
                                                            <select
                                                                id="batch_no"
                                                                className="form-control select2"
                                                                value={newRecord.batch_no}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value="">Select a batch number</option>
                                                                {batchNumbers.map(batchNo => (
                                                                    <option key={batchNo} value={batchNo}>{batchNo}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Title Training</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="training_title"
                                                                value={newRecord.training_title}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value="">Select Training Title</option>
                                                                {trainingTitle.map((item) => (
                                                                    <option key={item.mas_id} value={item.training_title}>
                                                                        {item.training_title}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('sr_no')}>Roll No {fe('sr_no') && <span>*</span>}</label>
                                                            <input
                                                                id="sr_no"
                                                                type="text"
                                                                className={inputCls('sr_no')}
                                                                value={newRecord.sr_no}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Organization</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="organization"
                                                                value={newRecord.organization}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value="">Select Organization</option>
                                                                {organization.map((item) => (
                                                                    <option key={item.mas_id} value={item.organ_name}>
                                                                        {item.organ_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label class="form-label text-primary fw-bold">Work Location</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="work_location"
                                                                value={newRecord.work_location}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value="">Select Work Location</option>
                                                                {workLocation.map((item) => (
                                                                    <option key={item.mas_id} value={item.loc_name}>
                                                                        {item.loc_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('incharge')}>Incharge {fe('incharge') && <span>*</span>}</label>
                                                            <input
                                                                id="incharge"
                                                                type="text"
                                                                className={inputCls('incharge')}
                                                                value={newRecord.incharge}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('sub_contractor')}>Sub Contractor {fe('sub_contractor') && <span>*</span>}</label>
                                                            <input
                                                                id="sub_contractor"
                                                                type="text"
                                                                className={inputCls('sub_contractor')}
                                                                value={newRecord.sub_contractor}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('evaluation_option')}>Evaluation Options {fe('evaluation_option') && <span>*</span>}</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="evaluation_option"
                                                                value={newRecord.evaluation_option}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="With Evaluation">With Evaluation</option>
                                                                <option value="Without Evaluation">Without Evaluation</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('payment_made_by')}>Payment Made By {fe('payment_made_by') && <span>*</span>}</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="payment_made_by"
                                                                value={newRecord.payment_made_by}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value="">Select Organization</option>
                                                                {organization.map((item) => (
                                                                    <option key={item.mas_id} value={item.organ_name}>
                                                                        {item.organ_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('contract_number')}>Contract Number {fe('contract_number') && <span>*</span>}</label>
                                                            <input
                                                                id="contract_number"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.contract_number}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-4'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('passport_size')}>Passport Size Photo {fe('passport_size') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-id-card"></i></span>
                                                                </div>
                                                                <input
                                                                    ref={fileInputRef}
                                                                    name="passport_size"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="form-control"
                                                                    onChange={handleFileChange}
                                                                    disabled
                                                                />
                                                            </div>
                                                            <small className="form-text text-muted">Upload a clear passport-size photo (jpg/png).</small>
                                                            {newRecord.passport_size && typeof newRecord.passport_size === "string" && (
                                                                <div className="mt-2">
                                                                    <a href={`${newRecord.passport_size}`} target="_blank" rel="noopener noreferrer">
                                                                        View Uploaded Passport Photo
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className={labelCls('stamp_size')}>Stamp Size Photo {fe('stamp_size') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-stamp"></i></span>
                                                                </div>
                                                                <input
                                                                    name="stamp_size"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="form-control"
                                                                    onChange={handleFileChange}
                                                                    disabled
                                                                />
                                                            </div>
                                                            <small className="form-text text-muted">Upload a clear stamp-size photo (jpg/png).</small>
                                                            {newRecord.stamp_size && typeof newRecord.stamp_size === "string" && (
                                                                <div className="mt-2">
                                                                    <a href={newRecord.stamp_size} target="_blank" rel="noopener noreferrer">
                                                                        View Uploaded Stamp Photo
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('Name')}>Name {fe('Name') && <span>*</span>}</label>
                                                            <input
                                                                id="Name"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.Name}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('designation')}>Designation {fe('designation') && <span>*</span>}</label>
                                                            <input
                                                                id="designation"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.designation}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('contact_no')}>Contact No {fe('contact_no') && <span>*</span>}</label>
                                                            <input
                                                                id="contact_no"
                                                                type="text"
                                                                className={inputCls('contact_no')}
                                                                value={newRecord.contact_no}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('qualification')}>Qualification {fe('qualification') && <span>*</span>}</label>
                                                            <input
                                                                id="qualification"
                                                                type="text"
                                                                className={inputCls('qualification')}
                                                                value={newRecord.qualification}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('date_of_birth')}>Date of Birth {fe('date_of_birth') && <span>*</span>}</label>
                                                            <input
                                                                id="date_of_birth"
                                                                type="date"
                                                                value={newRecord.date_of_birth} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        date_of_birth: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('languages_known')}>Languages Known {fe('languages_known') && <span>*</span>}</label>
                                                            <input
                                                                id="languages_known"
                                                                type="text"
                                                                className={inputCls('languages_known')}
                                                                value={newRecord.languages_known}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>


                                                    <div class="form-section mt-4">
                                                        <h4 class="text-primary">Experience</h4>
                                                        <hr />
                                                    </div>


                                                    <div class="row mb-3">
                                                        <div class="col-md-6">
                                                            <label className={labelCls('total_year_exp')}>Total Year Experience {fe('total_year_exp') && <span>*</span>}</label>
                                                            <input type="text" id="total_year_exp" class="form-control" value={newRecord.total_year_exp} onChange={handleInputChange} disabled />
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label className={labelCls('current_employer')}>Current Employer {fe('current_employer') && <span>*</span>}</label>
                                                            <input type="text" id="current_employer" class="form-control" value={newRecord.current_employer} onChange={handleInputChange} disabled />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('LMV_HMV_license_no')}>LMV/HMV License No & Details {fe('LMV_HMV_license_no') && <span>*</span>}</label>
                                                            <input
                                                                id="LMV_HMV_license_no"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.LMV_HMV_license_no}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('types_of_cranes_handled')}>Driving License Type {fe('types_of_cranes_handled') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('types_of_cranes_handled')}
                                                                id="types_of_cranes_handled"
                                                                value={newRecord.types_of_cranes_handled}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value="">Select License Type</option>
                                                                {licenseType.map((item) => (
                                                                    <option key={item.mas_id} value={item.driving_li_type}>
                                                                        {item.driving_li_type}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('marital_status')}>Marital Status {fe('marital_status') && <span>*</span>}</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="marital_status"
                                                                value={newRecord.marital_status}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="Single">Single</option>
                                                                <option value="Married">Married</option>
                                                            </select>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className={labelCls('aadhaar_no')}>Aadhaar No {fe('aadhaar_no') && <span>*</span>}</label>
                                                            <input
                                                                id="aadhaar_no"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.aadhaar_no}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('id_card')}>ID Card {fe('id_card') && <span>*</span>}</label>
                                                            <input
                                                                id="id_card"
                                                                type="text"
                                                                className="form-control"
                                                                value={newRecord.id_card}
                                                                onChange={handleInputChange}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-md-6">
                                                            <label htmlFor="present_address" className={labelCls('present_address')}>Present Address {fe('present_address') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-map-marker-alt"></i></span>
                                                                </div>
                                                                <input
                                                                    id="present_address"
                                                                    type="text"
                                                                    className={inputCls('present_address')}
                                                                    placeholder="Enter present address"
                                                                    value={newRecord.present_address || ""}
                                                                    onChange={handleInputChange}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 d-flex align-items-end">
                                                            <div className="form-check mt-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="sameAddress"
                                                                    checked={isAddressSame}
                                                                    onChange={(e) => handleCheckboxChange(e)}
                                                                    disabled
                                                                />
                                                                <label className="form-check-label" htmlFor="sameAddress">
                                                                    Same as Present Address
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-md-6">
                                                            <label htmlFor="permanent_address" className={labelCls('permanent_address')}>Permanent Address {fe('permanent_address') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-home"></i></span>
                                                                </div>
                                                                <input
                                                                    id="permanent_address"
                                                                    type="text"
                                                                    className={inputCls('permanent_address')}
                                                                    placeholder="Enter permanent address"
                                                                    value={newRecord.permanent_address || ""}
                                                                    onChange={handleInputChange}
                                                                    disabled={isAddressSame}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('license_valid_from')}>License Valid From {fe('license_valid_from') && <span>*</span>}</label>
                                                            <input
                                                                id="license_valid_from"
                                                                type="date"
                                                                value={newRecord.license_valid_from}
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value;
                                                                    setNewRecord(prevState => ({ ...prevState, license_valid_from: dateValue }));
                                                                    if (formErrors.license_valid_from) setFormErrors(prev => { const n = { ...prev }; delete n.license_valid_from; return n; });
                                                                }}
                                                                className={inputCls('license_valid_from')}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('license_valid_to')}>License Valid To {fe('license_valid_to') && <span>*</span>}</label>
                                                            <input
                                                                id="license_valid_to"
                                                                type="date"
                                                                value={newRecord.license_valid_to} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value;
                                                                    setNewRecord(prevState => ({ ...prevState, license_valid_to: dateValue }));
                                                                    if (formErrors.license_valid_to) setFormErrors(prev => { const n = { ...prev }; delete n.license_valid_to; return n; });
                                                                }}
                                                                className={inputCls('license_valid_to')}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>

                                                    <div class="form-section mt-4">
                                                        <h4 class="text-primary">EWE - Officials</h4>
                                                        <hr />
                                                    </div>

                                                    <div class="row mb-3">
                                                        <div class="col-md-6">
                                                            <label className={labelCls('checked_by')}>Checked By {fe('checked_by') && <span>*</span>}</label>
                                                            <select class="form-control select2" id="checked_by" value={newRecord.checked_by} onChange={handleInputChange} disabled>
                                                                <option value="">Select Checked By</option>
                                                                {trainerName.map((item) => (
                                                                    <option key={item.mas_id} value={item.trainer_name}>{item.trainer_name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label className={labelCls('verify_by')}>Verified By {fe('verify_by') && <span>*</span>}</label>
                                                            <select class="form-control select2" id="verify_by" value={newRecord.verify_by} onChange={handleInputChange} disabled>
                                                                <option value="">Select Verified By</option>
                                                                {trainerName.map((item) => (
                                                                    <option key={item.mas_id} value={item.trainer_name}>{item.trainer_name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Edit Modal */}
                                <div className="modal fade" id="editRowModal">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary text-white">
                                                <h4 className="modal-title"><i class="fas fa-user-plus mr-2"></i> Edit Candidate Registration</h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleFormSubmit}>

                                                    <div className='row mb-3'>
                                                        <div className="col-md-4">
                                                            <label class="form-label text-primary fw-bold">Registration Form</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="reg_form"
                                                                value={newRecord.reg_form}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="Fresh">Fresh</option>
                                                                <option value="Renewal">Renewal</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label className={labelCls('candidate_type')}>Candidate Type {fe('candidate_type') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('candidate_type')}
                                                                id="candidate_type"
                                                                value={newRecord.candidate_type}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value=""></option>
                                                                <option value="Management">Management</option>
                                                                <option value="Plant & Machinery">Plant & Machinery</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <label class="form-label text-primary fw-bold">Certificate Type</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="certificate_type"
                                                                value={newRecord.certificate_type}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value=""></option>
                                                                <option value="BMRCL PM">BMRCL PM</option>
                                                                <option value="CMRL CPR">CMRL CPR</option>
                                                                <option value="CMRL MG">CMRL MG</option>
                                                                <option value="CMRL PM">CMRL PM</option>
                                                                <option value="MMRCL CPR">MMRCL CPR</option>
                                                                <option value="MMRCL PM">MMRCL PM</option>
                                                                <option value="PMCR">PMCR</option>
                                                                <option value="CMRL PM WSC">CMRL PM WSC</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className="col-md-6">
                                                            <label className={labelCls('training_atten_date')}>Training Atten Date {fe('training_atten_date') && <span>*</span>}</label>
                                                            <input
                                                                id="training_atten_date"
                                                                type="date"
                                                                value={newRecord.training_atten_date} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        training_atten_date: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                            />
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className={labelCls('training_date')}>Date Of Issue {fe('training_date') && <span>*</span>}</label>
                                                            <input
                                                                id="training_date"
                                                                type="date"
                                                                value={newRecord.training_date} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        training_date: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('batch_no')}>Batch No {fe('batch_no') && <span>*</span>}</label>
                                                            <select
                                                                id="batch_no"
                                                                className={selectCls('batch_no')}
                                                                value={newRecord.batch_no}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select a batch number</option>
                                                                {batchNumbers.map(batchNo => (
                                                                    <option key={batchNo} value={batchNo}>{batchNo}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('training_title')}>Title Training {fe('training_title') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('training_title')}
                                                                id="training_title"
                                                                value={newRecord.training_title}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Training Title</option>
                                                                {trainingTitle.map((item) => (
                                                                    <option key={item.mas_id} value={item.training_title}>
                                                                        {item.training_title}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('sr_no')}>Roll No {fe('sr_no') && <span>*</span>}</label>
                                                            <input
                                                                id="sr_no"
                                                                type="text"
                                                                className={inputCls('sr_no')}
                                                                value={newRecord.sr_no}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('organization')}>Organization {fe('organization') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('organization')}
                                                                id="organization"
                                                                value={newRecord.organization}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Organization</option>
                                                                {organization.map((item) => (
                                                                    <option key={item.mas_id} value={item.organ_name}>
                                                                        {item.organ_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('work_location')}>Work Location {fe('work_location') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('work_location')}
                                                                id="work_location"
                                                                value={newRecord.work_location}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Work Location</option>
                                                                {workLocation.map((item) => (
                                                                    <option key={item.mas_id} value={item.loc_name}>
                                                                        {item.loc_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('incharge')}>Incharge {fe('incharge') && <span>*</span>}</label>
                                                            <input
                                                                id="incharge"
                                                                type="text"
                                                                className={inputCls('incharge')}
                                                                value={newRecord.incharge}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('sub_contractor')}>Sub Contractor {fe('sub_contractor') && <span>*</span>}</label>
                                                            <input
                                                                id="sub_contractor"
                                                                type="text"
                                                                className={inputCls('sub_contractor')}
                                                                value={newRecord.sub_contractor}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('evaluation_option')}>Evaluation Options {fe('evaluation_option') && <span>*</span>}</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="evaluation_option"
                                                                value={newRecord.evaluation_option}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="With Evaluation">With Evaluation</option>
                                                                <option value="Without Evaluation">Without Evaluation</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('payment_made_by')}>Payment Made By {fe('payment_made_by') && <span>*</span>}</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="payment_made_by"
                                                                value={newRecord.payment_made_by}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Organization</option>
                                                                {organization.map((item) => (
                                                                    <option key={item.mas_id} value={item.organ_name}>
                                                                        {item.organ_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('contract_number')}>Contract Number {fe('contract_number') && <span>*</span>}</label>
                                                            <input
                                                                id="contract_number"
                                                                type="text"
                                                                className={inputCls('contract_number')}
                                                                value={newRecord.contract_number}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-4'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('passport_size')}>Passport Size Photo {fe('passport_size') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-id-card"></i></span>
                                                                </div>
                                                                <input
                                                                    ref={fileInputRef}
                                                                    name="passport_size"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="form-control"
                                                                    onChange={handleFileChange}
                                                                />
                                                            </div>
                                                            <small className="form-text text-muted">Upload a clear passport-size photo (jpg/png).</small>
                                                            {!imageSaved && fileInputs.passport_size && (
                                                                <div className="mt-2 d-flex align-items-center">
                                                                    <span className="text-warning font-weight-bold mr-2"><i className="fas fa-exclamation-triangle mr-1"></i>Image not saved!</span>
                                                                    <button type="button" className="btn btn-sm btn-warning" onClick={handleImageSave}>
                                                                        <i className="fas fa-upload mr-1"></i> Save Image Now
                                                                    </button>
                                                                </div>
                                                            )}
                                                            {imageSaved && fileInputs.passport_size && (
                                                                <div className="mt-1 text-success"><i className="fas fa-check-circle mr-1"></i>Image saved successfully</div>
                                                            )}
                                                            {newRecord.passport_size && typeof newRecord.passport_size === "string" && (
                                                                <div className="mt-2">
                                                                    <a href={`${newRecord.passport_size}`} target="_blank" rel="noopener noreferrer">
                                                                        View Uploaded Passport Photo
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className={labelCls('stamp_size')}>Stamp Size Photo {fe('stamp_size') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-stamp"></i></span>
                                                                </div>
                                                                <input
                                                                    name="stamp_size"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="form-control"
                                                                    onChange={handleFileChange}
                                                                />
                                                            </div>
                                                            <small className="form-text text-muted">Upload a clear stamp-size photo (jpg/png).</small>
                                                            {newRecord.stamp_size && typeof newRecord.stamp_size === "string" && (
                                                                <div className="mt-2">
                                                                    <a href={newRecord.stamp_size} target="_blank" rel="noopener noreferrer">
                                                                        View Uploaded Stamp Photo
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('Name')}>Name {fe('Name') && <span>*</span>}</label>
                                                            <input
                                                                id="Name"
                                                                type="text"
                                                                className={inputCls('Name')}
                                                                value={newRecord.Name}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('designation')}>Designation {fe('designation') && <span>*</span>}</label>
                                                            <input
                                                                id="designation"
                                                                type="text"
                                                                className={inputCls('designation')}
                                                                value={newRecord.designation}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('contact_no')}>Contact No {fe('contact_no') && <span>*</span>}</label>
                                                            <input
                                                                id="contact_no"
                                                                type="text"
                                                                className={inputCls('contact_no')}
                                                                value={newRecord.contact_no}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('qualification')}>Qualification {fe('qualification') && <span>*</span>}</label>
                                                            <input
                                                                id="qualification"
                                                                type="text"
                                                                className={inputCls('qualification')}
                                                                value={newRecord.qualification}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('date_of_birth')}>Date of Birth {fe('date_of_birth') && <span>*</span>}</label>
                                                            <input
                                                                id="date_of_birth"
                                                                type="date"
                                                                value={newRecord.date_of_birth} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value; // Get the input value in YYYY-MM-DD
                                                                    setNewRecord(prevState => ({
                                                                        ...prevState,
                                                                        date_of_birth: dateValue // Update state directly
                                                                    }));
                                                                }}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('languages_known')}>Languages Known {fe('languages_known') && <span>*</span>}</label>
                                                            <input
                                                                id="languages_known"
                                                                type="text"
                                                                className={inputCls('languages_known')}
                                                                value={newRecord.languages_known}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div class="form-section mt-4">
                                                        <h4 class="text-primary">Experience</h4>
                                                        <hr />
                                                    </div>


                                                    <div class="row mb-3">
                                                        <div class="col-md-6">
                                                            <label className={labelCls('total_year_exp')}>Total Year Experience {fe('total_year_exp') && <span>*</span>}</label>
                                                            <input type="text" id="total_year_exp" className={inputCls('total_year_exp')} value={newRecord.total_year_exp} onChange={handleInputChange} />
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label className={labelCls('current_employer')}>Current Employer {fe('current_employer') && <span>*</span>}</label>
                                                            <input type="text" id="current_employer" className={inputCls('current_employer')} value={newRecord.current_employer} onChange={handleInputChange} />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('LMV_HMV_license_no')}>LMV/HMV License No & Details {fe('LMV_HMV_license_no') && <span>*</span>}</label>
                                                            <input
                                                                id="LMV_HMV_license_no"
                                                                type="text"
                                                                className={inputCls('LMV_HMV_license_no')}
                                                                value={newRecord.LMV_HMV_license_no}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('types_of_cranes_handled')}>Driving License Type {fe('types_of_cranes_handled') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('types_of_cranes_handled')}
                                                                id="types_of_cranes_handled"
                                                                value={newRecord.types_of_cranes_handled}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select License Type</option>
                                                                {licenseType.map((item) => (
                                                                    <option key={item.mas_id} value={item.driving_li_type}>
                                                                        {item.driving_li_type}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('marital_status')}>Marital Status {fe('marital_status') && <span>*</span>}</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="marital_status"
                                                                value={newRecord.marital_status}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="Single">Single</option>
                                                                <option value="Married">Married</option>
                                                            </select>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className={labelCls('aadhaar_no')}>Aadhaar No {fe('aadhaar_no') && <span>*</span>}</label>
                                                            <input
                                                                id="aadhaar_no"
                                                                type="text"
                                                                className={inputCls('aadhaar_no')}
                                                                value={newRecord.aadhaar_no}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('id_card')}>ID Card {fe('id_card') && <span>*</span>}</label>
                                                            <input
                                                                id="id_card"
                                                                type="text"
                                                                className={inputCls('id_card')}
                                                                value={newRecord.id_card}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-md-6">
                                                            <label htmlFor="present_address" className={labelCls('present_address')}>Present Address {fe('present_address') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-map-marker-alt"></i></span>
                                                                </div>
                                                                <input
                                                                    id="present_address"
                                                                    type="text"
                                                                    className={inputCls('present_address')}
                                                                    placeholder="Enter present address"
                                                                    value={newRecord.present_address || ""}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 d-flex align-items-end">
                                                            <div className="form-check mt-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="sameAddress"
                                                                    checked={isAddressSame}
                                                                    onChange={(e) => handleCheckboxChange(e)}
                                                                />
                                                                <label className="form-check-label" htmlFor="sameAddress">
                                                                    Same as Present Address
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-md-6">
                                                            <label htmlFor="permanent_address" className={labelCls('permanent_address')}>Permanent Address {fe('permanent_address') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-home"></i></span>
                                                                </div>
                                                                <input
                                                                    id="permanent_address"
                                                                    type="text"
                                                                    className={inputCls('permanent_address')}
                                                                    placeholder="Enter permanent address"
                                                                    value={newRecord.permanent_address || ""}
                                                                    onChange={handleInputChange}
                                                                    disabled={isAddressSame}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('license_valid_from')}>License Valid From {fe('license_valid_from') && <span>*</span>}</label>
                                                            <input
                                                                id="license_valid_from"
                                                                type="date"
                                                                value={newRecord.license_valid_from}
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value;
                                                                    setNewRecord(prevState => ({ ...prevState, license_valid_from: dateValue }));
                                                                    if (formErrors.license_valid_from) setFormErrors(prev => { const n = { ...prev }; delete n.license_valid_from; return n; });
                                                                }}
                                                                className={inputCls('license_valid_from')}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('license_valid_to')}>License Valid To {fe('license_valid_to') && <span>*</span>}</label>
                                                            <input
                                                                id="license_valid_to"
                                                                type="date"
                                                                value={newRecord.license_valid_to} // Use the state variable
                                                                onChange={(e) => {
                                                                    const dateValue = e.target.value;
                                                                    setNewRecord(prevState => ({ ...prevState, license_valid_to: dateValue }));
                                                                    if (formErrors.license_valid_to) setFormErrors(prev => { const n = { ...prev }; delete n.license_valid_to; return n; });
                                                                }}
                                                                className={inputCls('license_valid_to')}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div class="form-section mt-4">
                                                        <h4 class="text-primary">EWE - Officials</h4>
                                                        <hr />
                                                    </div>

                                                    <div class="row mb-3">
                                                        <div class="col-md-6">
                                                            <label className={labelCls('checked_by')}>Checked By {fe('checked_by') && <span>*</span>}</label>
                                                            <select className={selectCls('checked_by')} id="checked_by" value={newRecord.checked_by} onChange={handleInputChange}>
                                                                <option value="">Select Checked By</option>
                                                                {trainerName.map((item) => (
                                                                    <option key={item.mas_id} value={item.trainer_name}>{item.trainer_name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label className={labelCls('verify_by')}>Verified By {fe('verify_by') && <span>*</span>}</label>
                                                            <select className={selectCls('verify_by')} id="verify_by" value={newRecord.verify_by} onChange={handleInputChange}>
                                                                <option value="">Select Verified By</option>
                                                                {trainerName.map((item) => (
                                                                    <option key={item.mas_id} value={item.trainer_name}>{item.trainer_name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer border-0">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary"
                                                            disabled={isSaving}
                                                        >
                                                            {isSaving ? 'Saving...' : 'Save'}
                                                        </button>
                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal" disabled={isSaving}>
                                                            <i class="fas fa-times mr-1"></i> Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Add New Record Modal */}
                                <div className="modal fade" id="addRowModal">
                                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                                        <div className="modal-content">
                                            <div className="modal-header bg-primary text-white">
                                                <h4 className="modal-title"><i class="fas fa-user-plus mr-2"></i> Add Candidate</h4>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handleCreateSubmit}>

                                                    <div className="row mb-3">
                                                        <div className="col-md-4">
                                                            <label class="form-label text-primary fw-bold">Registration Form</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="reg_form"
                                                                value={newRecord.reg_form}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="Fresh">Fresh</option>
                                                                <option value="Renewal">Renewal</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label className={labelCls('candidate_type')}>Candidate Type {fe('candidate_type') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('candidate_type')}
                                                                id="candidate_type"
                                                                value={newRecord.candidate_type}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value=""></option>
                                                                <option value="Management">Management</option>
                                                                <option value="Plant & Machinery">Plant & Machinery</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label class="form-label text-primary fw-bold">Certificate Type</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="certificate_type"
                                                                value={newRecord.certificate_type}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value=""></option>
                                                                <option value="BMRCL PM">BMRCL PM</option>
                                                                <option value="CMRL CPR">CMRL CPR</option>
                                                                <option value="CMRL MG">CMRL MG</option>
                                                                <option value="CMRL PM">CMRL PM</option>
                                                                <option value="MMRCL CPR">MMRCL CPR</option>
                                                                <option value="MMRCL PM">MMRCL PM</option>
                                                                <option value="PMCR">PMCR</option>
                                                                <option value="CMRL PM WSC">CMRL PM WSC</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('training_atten_date')}>Training Atten Date {fe('training_atten_date') && <span>*</span>}</label>
                                                            <input
                                                                type="date"
                                                                value={newRecord.training_atten_date} // Use 'value' instead of 'selected'
                                                                onChange={(e) => setNewRecord(prev => ({ ...prev, training_atten_date: e.target.value }))} // Get the date value from the event
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('training_date')}>Date Of Issue {fe('training_date') && <span>*</span>}</label>
                                                            <input
                                                                type="date"
                                                                value={newRecord.training_date}
                                                                onChange={(e) => setNewRecord(prev => ({ ...prev, training_date: e.target.value }))}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('batch_no')}>Batch No {fe('batch_no') && <span>*</span>}</label>
                                                            <select
                                                                id="batch_no"
                                                                className={selectCls('batch_no')}
                                                                value={newRecord.batch_no}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select a batch number</option>
                                                                {batchNumbers.map(batchNo => (
                                                                    <option key={batchNo} value={batchNo}>{batchNo}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('training_title')}>Title Training {fe('training_title') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('training_title')}
                                                                id="training_title"
                                                                value={newRecord.training_title}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Training Title</option>
                                                                {trainingTitle.map((item) => (
                                                                    <option key={item.mas_id} value={item.training_title}>
                                                                        {item.training_title}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('sr_no')}>Roll No {fe('sr_no') && <span>*</span>}</label>
                                                            <input
                                                                id="sr_no"
                                                                type="text"
                                                                className={inputCls('sr_no')}
                                                                value={newRecord.sr_no}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('organization')}>Organization {fe('organization') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('organization')}
                                                                id="organization"
                                                                value={newRecord.organization}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Organization</option>
                                                                {organization.map((item) => (
                                                                    <option key={item.mas_id} value={item.organ_name}>
                                                                        {item.organ_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('work_location')}>Work Location {fe('work_location') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('work_location')}
                                                                id="work_location"
                                                                value={newRecord.work_location}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Work Location</option>
                                                                {workLocation.map((item) => (
                                                                    <option key={item.mas_id} value={item.loc_name}>
                                                                        {item.loc_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('incharge')}>Incharge {fe('incharge') && <span>*</span>}</label>
                                                            <input
                                                                id="incharge"
                                                                type="text"
                                                                className={inputCls('incharge')}
                                                                value={newRecord.incharge}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('sub_contractor')}>Sub Contractor {fe('sub_contractor') && <span>*</span>}</label>
                                                            <input
                                                                id="sub_contractor"
                                                                type="text"
                                                                className={inputCls('sub_contractor')}
                                                                value={newRecord.sub_contractor}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('evaluation_option')}>Evaluation Options {fe('evaluation_option') && <span>*</span>}</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="evaluation_option"
                                                                value={newRecord.evaluation_option}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="With Evaluation">With Evaluation</option>
                                                                <option value="Without Evaluation">Without Evaluation</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('payment_made_by')}>Payment Made By {fe('payment_made_by') && <span>*</span>}</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="payment_made_by"
                                                                value={newRecord.payment_made_by}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select Organization</option>
                                                                {organization.map((item) => (
                                                                    <option key={item.mas_id} value={item.organ_name}>
                                                                        {item.organ_name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('contract_number')}>Contract Number {fe('contract_number') && <span>*</span>}</label>
                                                            <input
                                                                id="contract_number"
                                                                type="text"
                                                                className={inputCls('contract_number')}
                                                                value={newRecord.contract_number}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-4'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('passport_size')}>Passport Size Photo {fe('passport_size') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-id-card"></i></span>
                                                                </div>
                                                                <input
                                                                    ref={fileInputRef}
                                                                    name="passport_size"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="form-control"
                                                                    onChange={handleFileChange}
                                                                />
                                                            </div>
                                                            <small className="form-text text-muted">Upload a clear passport-size photo (jpg/png).</small>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className={labelCls('stamp_size')}>Stamp Size Photo {fe('stamp_size') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-stamp"></i></span>
                                                                </div>
                                                                <input
                                                                    name="stamp_size"
                                                                    type="file"
                                                                    accept="image/*"
                                                                    className="form-control"
                                                                    onChange={handleFileChange}
                                                                />
                                                            </div>
                                                            <small className="form-text text-muted">Upload a clear stamp-size photo (jpg/png).</small>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('Name')}>Name {fe('Name') && <span>*</span>}</label>
                                                            <input
                                                                id="Name"
                                                                type="text"
                                                                className={inputCls('Name')}
                                                                value={newRecord.Name}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('designation')}>Designation {fe('designation') && <span>*</span>}</label>
                                                            <input
                                                                id="designation"
                                                                type="text"
                                                                className={inputCls('designation')}
                                                                value={newRecord.designation}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('contact_no')}>Contact No {fe('contact_no') && <span>*</span>}</label>
                                                            <input
                                                                id="contact_no"
                                                                type="text"
                                                                className={inputCls('contact_no')}
                                                                value={newRecord.contact_no}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('qualification')}>Qualification {fe('qualification') && <span>*</span>}</label>
                                                            <input
                                                                id="qualification"
                                                                type="text"
                                                                className={inputCls('qualification')}
                                                                value={newRecord.qualification}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('date_of_birth')}>Date of Birth {fe('date_of_birth') && <span>*</span>}</label>
                                                            <input
                                                                type="date"
                                                                value={newRecord.date_of_birth}
                                                                onChange={(e) => setNewRecord(prev => ({ ...prev, date_of_birth: e.target.value }))}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('languages_known')}>Languages Known {fe('languages_known') && <span>*</span>}</label>
                                                            <input
                                                                id="languages_known"
                                                                type="text"
                                                                className={inputCls('languages_known')}
                                                                value={newRecord.languages_known}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div class="form-section mt-4">
                                                        <h4 class="text-primary">Experience</h4>
                                                        <hr />
                                                    </div>


                                                    <div class="row mb-3">
                                                        <div class="col-md-6">
                                                            <label className={labelCls('total_year_exp')}>Total Year Experience {fe('total_year_exp') && <span>*</span>}</label>
                                                            <input type="text" id="total_year_exp" className={inputCls('total_year_exp')} value={newRecord.total_year_exp} onChange={handleInputChange} />
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label className={labelCls('current_employer')}>Current Employer {fe('current_employer') && <span>*</span>}</label>
                                                            <input type="text" id="current_employer" className={inputCls('current_employer')} value={newRecord.current_employer} onChange={handleInputChange} />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('LMV_HMV_license_no')}>LMV/HMV License No & Details {fe('LMV_HMV_license_no') && <span>*</span>}</label>
                                                            <input
                                                                id="LMV_HMV_license_no"
                                                                type="text"
                                                                className={inputCls('LMV_HMV_license_no')}
                                                                value={newRecord.LMV_HMV_license_no}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('types_of_cranes_handled')}>Driving License Type {fe('types_of_cranes_handled') && <span>*</span>}</label>
                                                            <select
                                                                className={selectCls('types_of_cranes_handled')}
                                                                id="types_of_cranes_handled"
                                                                value={newRecord.types_of_cranes_handled}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select License Type</option>
                                                                {licenseType.map((item) => (
                                                                    <option key={item.mas_id} value={item.driving_li_type}>
                                                                        {item.driving_li_type}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('marital_status')}>Marital Status {fe('marital_status') && <span>*</span>}</label>
                                                            <select
                                                                className="form-control select2"
                                                                id="marital_status"
                                                                value={newRecord.marital_status}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value="Single">Single</option>
                                                                <option value="Married">Married</option>
                                                            </select>
                                                        </div>

                                                        <div className='col-md-6'>
                                                            <label className={labelCls('aadhaar_no')}>Aadhaar No {fe('aadhaar_no') && <span>*</span>}</label>
                                                            <input
                                                                id="aadhaar_no"
                                                                type="text"
                                                                className={inputCls('aadhaar_no')}
                                                                value={newRecord.aadhaar_no}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('id_card')}>ID Card {fe('id_card') && <span>*</span>}</label>
                                                            <input
                                                                id="id_card"
                                                                type="text"
                                                                className={inputCls('id_card')}
                                                                value={newRecord.id_card}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-md-6">
                                                            <label htmlFor="present_address" className={labelCls('present_address')}>Present Address {fe('present_address') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-map-marker-alt"></i></span>
                                                                </div>
                                                                <input
                                                                    id="present_address"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter present address"
                                                                    value={newRecord.present_address}
                                                                    onChange={handleInputChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 d-flex align-items-end">
                                                            <div className="form-check mt-4">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="sameAddress"
                                                                    onChange={(e) => handleCheckboxChange(e)}
                                                                />
                                                                <label className="form-check-label" htmlFor="sameAddress">
                                                                    Same as Present Address
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-md-6">
                                                            <label htmlFor="permanent_address" className={labelCls('permanent_address')}>Permanent Address {fe('permanent_address') && <span>*</span>}</label>
                                                            <div className="input-group">
                                                                <div className="input-group-prepend">
                                                                    <span className="input-group-text bg-light"><i className="fas fa-home"></i></span>
                                                                </div>
                                                                <input
                                                                    id="permanent_address"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter permanent address"
                                                                    value={newRecord.permanent_address}
                                                                    onChange={handleInputChange}
                                                                    disabled={isAddressSame}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='row mb-3'>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('license_valid_from')}>License Valid From {fe('license_valid_from') && <span>*</span>}</label>
                                                            <input
                                                                id="license_valid_from"
                                                                type="date"
                                                                value={newRecord.license_valid_from}
                                                                onChange={(e) => setNewRecord(prev => ({ ...prev, license_valid_from: e.target.value }))}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <label className={labelCls('license_valid_to')}>License Valid To {fe('license_valid_to') && <span>*</span>}</label>
                                                            <input
                                                                id="license_valid_to"
                                                                type="date"
                                                                selected={newRecord.license_valid_to}
                                                                onChange={(e) => setNewRecord(prev => ({ ...prev, license_valid_to: e.target.value }))}
                                                                className="form-control"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div class="form-section mt-4">
                                                        <h4 class="text-primary">EWE - Officials</h4>
                                                        <hr />
                                                    </div>

                                                    <div class="row mb-3">
                                                        <div class="col-md-6">
                                                            <label className={labelCls('checked_by')}>Checked By {fe('checked_by') && <span>*</span>}</label>
                                                            <select className={selectCls('checked_by')} id="checked_by" value={newRecord.checked_by} onChange={handleInputChange}>
                                                                <option value="">Select Checked By</option>
                                                                {trainerName.map((item) => (
                                                                    <option key={item.mas_id} value={item.trainer_name}>{item.trainer_name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div class="col-md-6">
                                                            <label className={labelCls('verify_by')}>Verified By {fe('verify_by') && <span>*</span>}</label>
                                                            <select className={selectCls('verify_by')} id="verify_by" value={newRecord.verify_by} onChange={handleInputChange}>
                                                                <option value="">Select Verified By</option>
                                                                {trainerName.map((item) => (
                                                                    <option key={item.mas_id} value={item.trainer_name}>{item.trainer_name}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div class="modal-footer border-0">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-success"
                                                            disabled={isSaving}
                                                        >
                                                            {isSaving ? 'Saving...' : 'Create'}
                                                        </button>
                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal" disabled={isSaving}>
                                                            <i class="fas fa-times mr-1"></i> Close
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Print Section - Hidden by default */}
                                <div id="print_registration_section" style={{
                                    display: "none",
                                    width: "210mm",
                                    minHeight: "297mm",
                                    padding: "5mm",
                                    fontSize: "9px",
                                    fontFamily: "Arial, sans-serif",
                                    color: "#000",
                                    lineHeight: "1.1",
                                }}>
                                    {newRecord && Object.keys(newRecord).length > 0 && (
                                        <div className="cs-container" style={{
                                            fontFamily: 'Arial, sans-serif',
                                            maxWidth: '800px',
                                            margin: '0 auto',
                                            padding: '5px',
                                            border: '1px solid #000',
                                            backgroundColor: 'white'
                                        }}>
                                            <div className="cs-invoice cs-style1">
                                                <div className="cs-invoice_in">
                                                    {/* Header Section */}
                                                    <div className="cs-invoice_head cs-type1 cs-mb25" style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        marginBottom: '10px',
                                                        borderBottom: '1px solid #000'
                                                    }}>
                                                        <div className="cs-invoice_left custom-invoice-left" style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '12px'
                                                        }}>
                                                            <div style={{
                                                                width: '70px',
                                                                height: '70px',
                                                                flexShrink: 0,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                            }}>
                                                                <img src="dist/img/eazylogo.png" alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }}></img>
                                                            </div>
                                                            <div style={{ flex: 1 }}>
                                                                <p style={{
                                                                    fontSize: '21px',
                                                                    fontWeight: 'bold',
                                                                    margin: '0 0 4px 0',
                                                                    color: '#000',
                                                                    textAlign: 'left',
                                                                    whiteSpace: 'nowrap'
                                                                }}>
                                                                    EAZYWORLD EHS ENGINEERING PRIVATE LIMITED
                                                                </p>
                                                                <p style={{
                                                                    fontSize: '12px',
                                                                    fontWeight: '500',
                                                                    margin: '0',
                                                                    color: '#000',
                                                                    textAlign: 'left'
                                                                }}>
                                                                    ISO 9001-2015 / 10002-2018 / 14001-2018 / 21001-2018 &amp; 45001-2018 CERTIFIED COMPANY
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Second Header Section */}
                                                    <div className="cs-invoice_head cs-type1 cs-mb25" style={{
                                                        marginBottom: '10px',
                                                    }}>
                                                        {/* First Row */}
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'flex-start',
                                                            marginBottom: '10px'
                                                        }}>
                                                            {/* Left: Date at bottom */}
                                                            <div style={{
                                                                width: '15%',
                                                                display: 'flex',
                                                                alignItems: 'flex-end',
                                                                minHeight: '120px'
                                                            }}>
                                                                <span style={{
                                                                    fontSize: '15px',
                                                                    fontWeight: 'bold',
                                                                    whiteSpace: 'nowrap'
                                                                }}>
                                                                    DATE: {newRecord?.training_date ? new Date(newRecord.training_date).toLocaleDateString('en-GB') : ""}
                                                                </span>
                                                            </div>

                                                            {/* Center: Form Title */}
                                                            <div className="form-title" style={{
                                                                width: '60%',
                                                                textAlign: 'center',
                                                                backgroundColor: '#f0f0f0',
                                                                padding: '10px 0'
                                                            }}>
                                                                <h3 style={{ fontSize: '16px', margin: '0 0 10px 0' }}>
                                                                    CANDIDATE REGISTRATION FORM
                                                                </h3>
                                                                <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', fontSize: '13px', marginTop: '6px', textAlign: 'center' }}>
                                                                    Training Title: "{newRecord?.training_title}"
                                                                </div>
                                                            </div>

                                                            {/* Right: Passport Image */}
                                                            <div
                                                                className="cs-invoice_right"
                                                                style={{
                                                                    width: "25%",
                                                                    display: "flex",
                                                                    justifyContent: "flex-end",
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        width: "100px",
                                                                        height: "120px",
                                                                        border: "1px solid #ccc",
                                                                        backgroundColor: "#f9f9f9",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                    }}
                                                                >
                                                                    {newRecord?.passport_size ? (
                                                                        <>
                                                                            <img
                                                                                src={newRecord.passport_size}
                                                                                alt="Passport"
                                                                                style={{
                                                                                    maxWidth: "100%",
                                                                                    maxHeight: "100%",
                                                                                    objectFit: "cover",
                                                                                }}
                                                                                onError={(e) => {
                                                                                    const retries = parseInt(e.target.getAttribute('data-retries') || '0');
                                                                                    if (retries < 3) {
                                                                                        e.target.setAttribute('data-retries', String(retries + 1));
                                                                                        const base = newRecord.passport_size.split('?')[0];
                                                                                        setTimeout(() => {
                                                                                            e.target.src = base + '?t=' + Date.now();
                                                                                        }, 2000 * (retries + 1));
                                                                                    } else {
                                                                                        e.target.style.display = 'none';
                                                                                        const placeholder = e.target.nextElementSibling;
                                                                                        if (placeholder) placeholder.style.display = 'flex';
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <span style={{
                                                                                display: 'none',
                                                                                fontSize: '11px',
                                                                                color: '#aaa',
                                                                                width: '100%',
                                                                                height: '100%',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                textAlign: 'center',
                                                                            }}>Photo</span>
                                                                        </>
                                                                    ) : (
                                                                        <p style={{ fontSize: "10px" }}>No Image</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Form Table */}
                                                    <div className="cs-table cs-style1">
                                                        <div className="cs-round_border">
                                                            <table style={{
                                                                width: '100%',
                                                                borderCollapse: 'collapse',
                                                                margin: '5px 0'
                                                            }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold',
                                                                            width: '200px'
                                                                        }}>Name:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            minHeight: '25px'
                                                                        }}>{newRecord?.Name || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold',
                                                                            width: '200px'
                                                                        }}>Candidate Type:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            minHeight: '25px'
                                                                        }}>{newRecord?.candidate_type || ""}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold',
                                                                            width: '200px'
                                                                        }}>Batch No:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            minHeight: '25px'
                                                                        }}>{newRecord?.batch_no || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold',
                                                                            width: '200px'
                                                                        }}>Certificate Reference:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            minHeight: '25px'
                                                                        }}>{newRecord?.sr_no || ""}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Organization:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.organization || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Designation:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.designation || ""}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Work Location:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.work_location || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Phone No:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.contact_no || ""}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Contract Number:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.contract_number || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Contractor Name:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.sub_contractor || ""}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>License No:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.LMV_HMV_license_no || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>License Expiry Date:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.license_valid_to ? new Date(newRecord.license_valid_to).toLocaleDateString('en-GB') : "NIL"}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Incharge:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.incharge || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Total experience:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.total_year_exp || ""}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Evaluation Options:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.evaluation_option || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>DOB:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.date_of_birth ? new Date(newRecord.date_of_birth).toLocaleDateString('en-GB') : ""}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Languages known:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.languages_known || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Qualification:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.qualification || ""}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Aadhaar No:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.aadhaar_no || ""}</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold'
                                                                        }}>Marital Status:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px'
                                                                        }}>{newRecord?.marital_status || ""}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold',
                                                                            verticalAlign: 'top'
                                                                        }}>Scope Of Work / Equipment's Operated</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            height: '80px',
                                                                            verticalAlign: 'top'
                                                                        }} colSpan="3?."></td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            backgroundColor: '#f9f9f9',
                                                                            fontWeight: 'bold',
                                                                            verticalAlign: 'top'
                                                                        }}>Permanent Address:</td>
                                                                        <td style={{
                                                                            border: '1px solid #000',
                                                                            padding: '8px',
                                                                            height: '60px',
                                                                            verticalAlign: 'top'
                                                                        }} colSpan="3">{newRecord?.permanent_address || ""}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                    {/* CANDIDATE SIGN with dotted box (not full width) */}
                                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px', gap: '12px' }}>
                                                        <strong style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>CANDIDATE SIGN:</strong>
                                                        <div style={{
                                                            width: '200px',
                                                            height: '55px',
                                                            border: '1px dashed #000'
                                                        }}></div>
                                                    </div>

                                                    {/* Outer box: EWE Officials + Remarks + Checked/Verified/Authorized */}
                                                    <div style={{ border: '1px solid #000', marginTop: '10px' }}>

                                                        {/* EWE Officials row */}
                                                        <div style={{ padding: '6px 10px 12px' }}>
                                                            <strong style={{ fontSize: '13px' }}>EWE Officials:</strong>
                                                        </div>

                                                        {/* Remarks row with underline */}
                                                        <div style={{ padding: '6px 10px', borderBottom: '1px solid #000', display: 'flex', alignItems: 'flex-end', gap: '6px', paddingBottom: '10px' }}>
                                                            <strong style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>Remarks :</strong>
                                                        </div>

                                                        {/* Checked by / Verified by / Authorized by */}
                                                        <div style={{ display: 'flex' }}>
                                                            {[
                                                                { label: 'Checked by', name: printSignatures?.checkedBy },
                                                                { label: 'Verified by', name: printSignatures?.verifiedBy },
                                                                { label: 'Authorized by', name: printSignatures?.authorizedBy },
                                                            ].map((item, i, arr) => (
                                                                <div key={item.label} style={{
                                                                    flex: 1,
                                                                    textAlign: 'center',
                                                                    fontSize: '13px',
                                                                    padding: '6px 0 14px',
                                                                    borderRight: i < arr.length - 1 ? '1px solid #000' : 'none',
                                                                    display: 'flex',
                                                                    flexDirection: 'column',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'flex-end'
                                                                }}>
                                                                    <div style={{ flex: 1 }}></div>
                                                                    {item.name && (
                                                                        <div style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '2px' }}>
                                                                            {item.name}
                                                                        </div>
                                                                    )}
                                                                    <div style={{ borderTop: '1px dashed #000', width: '70%', margin: '0 auto 6px' }}></div>
                                                                    <strong>{item.label}</strong>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default CandidateRegistration;
